import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpErrorInterface, HttpInterface, HttpOptions } from '@core';
import { Observable } from 'rxjs';
import { LocalStoreEnum } from './../../shared/models/enum/local-store.enum';
import { URL_SYSTEM } from './../utils/constant';
import { LocalStoreManagerService } from './local-store-manager.service';

export enum Verbs {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  DELETE = 'DELETE'
}

@Injectable({ providedIn: 'root' })
export class HttpClientService {

  constructor(
    private http: HttpClient,
    private localStore: LocalStoreManagerService
  ) {
  }

  get<T>(options: HttpOptions): Observable<T> {
    return this.httpCall(Verbs.GET, options);
  }

  delete<T>(options: HttpOptions): Observable<T> {
    return this.httpCall(Verbs.DELETE, options);
  }

  post<T>(options: HttpOptions): Observable<T> {
    return this.httpCall(Verbs.POST, options);
  }

  put<T>(options: HttpOptions): Observable<T> {
    return this.httpCall(Verbs.PUT, options);
  }

  upload(options: HttpOptions) {
    options.body = options.body ?? null;
    options.headers = options.headers ?? {};
    options.isAuthentication = options.isAuthentication ?? true;
    if (options.isAuthentication) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${this.localStore.getData(LocalStoreEnum.Token)}` };
    }
    return this.http.post<Blob>(`${options.url ?? URL_SYSTEM}/${options.path}`, options.body, {
      headers: options.headers,
      observe: 'response',
      responseType: 'blob' as 'json',
      params: options.params ?? null
    });
  }

  httpCall<T>(verb: Verbs, options: HttpOptions): Observable<T> {
    const user = this.localStore.getData(LocalStoreEnum.User_Infor);
    // Setup default values
    options.body = options.body ?? null;
    options.headers = options.headers ?? {};
    options.isAuthentication = options.isAuthentication ?? true;
    if (options.isAuthentication) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${this.localStore.getData(LocalStoreEnum.Token)}` };
    }
    return this.http.request<T>(verb, `${options.url ?? URL_SYSTEM}/${options.path}`, {
      body: options.body,
      headers: options.headers,
      params: options.params ?? null
    });
  }
}

export declare interface NgOnHttp {
  onSuccess(response: HttpInterface<any>): void;
  onError(error: HttpErrorInterface): void;
}


